//import I18n from "i18n-js/index.js.erb"

var ProductBuilderErrors = {
  general: function (errors) {

    if (errors && errors.header_errors) {
      errors = errors.header_errors
      var err = [];
  
      if (errors.base && errors.base.length) {
        for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
          err.push(errors.base[i]);
        }
      }

      var field_names = [
        'name',
        'code',
        'amount',
        'frequency',
        'receipt_location',
        'image_group',
        'default_assigned_to',
      ];
  
      for (var i = 0, ilen = field_names.length; i < ilen; i++) {
        var field_errors = errors[field_names[i]];
        if (field_errors && field_errors.length) {
          for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
            err.push(I18n.t(field_names[i]) + ' ' + field_errors[j]);
          }
        }
      }
  
      return err;
    }

    return []
  },

  room_types: function (errors) {
    if (errors && errors.header_errors) {
      errors = errors.header_errors
      var err = [];
  
      if (errors.base && errors.base.length) {
        for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
          err.push(errors.base[i]);
        }
      }

      
  
      var field_names = [
        'room_types'
      ];
  
      for (var i = 0, ilen = field_names.length; i < ilen; i++) {
        var field_errors = errors[field_names[i]];
        if (field_errors && field_errors.length) {
          for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
            err.push(field_errors[j]);
          }
        }
      }
  
      return err;
    } 
    return []
  }
}

export default ProductBuilderErrors